import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Grid } from 'semantic-ui-react';
import styled from 'styled-components';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import GoogleLogin from 'react-google-login';
import { get, has } from 'lodash';
import { push } from 'react-router-redux';

import {
  resetGithubState,
  resetLinkedinState,
  googleLoginViaLogin,
  signIn,
  accountSignIn
} from '../actions';
import { Input } from '../../uiStandard/event/input';
// import { OrginalButton } from '../../uiStandard/event/button';
import { FormSubmitButton } from '../../uiStandard/event/formInput';
// import { Checkbox } from '../../uiStandard/event/checkbox';
import { FORM_NAME } from '../forms/formConstant';
import { CONFIG } from '../../config';
import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';

const formikEnhancer = withFormik({
  enableReinitialize: true,
  validationSchema: ({ translate, user }) => {
    const validationShape = {
      email: Yup.string()
        .email(translate('form.error.string.email'))
        .required(translate('form.error.mixed.required'))
    };

    if (!user.thirdPartyFrom) {
      validationShape.password = Yup.string()
        .max(32, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required'));
    }

    return Yup.object().shape(validationShape);
  },
  mapPropsToValues: ({ user }) => ({
    email: user.thirdPartyEmail || '',
    password: ''
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    // TODO refactor callback with signInFailed var
    // refactor actions and reducers by
    // seperating them into multiple files and use of Promise see example in rekit
    // be aware of how to handle the logic flow
    setSubmitting(true);

    const formData = { ...values };
    if (props.user.thirdPartyIdentification && props.user.thirdPartyFrom) {
      formData.thirdPartyType = props.user.thirdPartyFrom;
      formData.thirdPartyIdentification = props.user.thirdPartyIdentification;
    }

    props.accountSignIn(formData).then(signInFailed => {
      if (signInFailed) setSubmitting(false);
    });
  },
  displayName: FORM_NAME.LOGIN_FORM
});

const RegularInput = styled(Input)`
  width: 338px;
  @media (max-width: 768px) {
    width: auto;
  }
`;

const RegularButton = styled(FormSubmitButton)`
  min-height: 41.13px;
  width: 338px;
  @media (max-width: 768px) {
    width: auto;
  }
`;

// const RemeberMeCheckbox = styled(Checkbox)`
//   width: auto;
// `;

const AccountLoginForm = props => {
  const {
    handleSubmit, translate, isSubmitting
  } = props;

  const styles = {
    gridRowPadding: {
      paddingTop: '7px',
      paddingBottom: '7px'
    }
  };

  const toResetPassword = (e) => {
    e.preventDefault();
    props.push('/reset_password_v2');
  };

  const toSignupLink = (e) => {
    e.preventDefault();
    props.push('/signup');
  };

  const googleLogin = (googleUser) => {
    const payload = {
      id: googleUser.getBasicProfile().getId(),
      email: googleUser.getBasicProfile().getEmail(),
      from: 'Google',
      firstName: googleUser.getBasicProfile().getGivenName() || '',
      lastName: googleUser.getBasicProfile().getFamilyName() || '',
      googleUser
    };

    props.googleLoginViaLogin(payload, async (res) => {
      const { ifHHAccWithSameEmailExist } = res;
      if (has(res, 'correctThirdPartyPlatform') && get(res, 'correctThirdPartyPlatform')) {
        HHAlert({ id: `alert.error.incorrectThirdPartyPlatform${get(res, 'correctThirdPartyPlatform')}` }, ALERT_TYPE.ERROR);
      } else if (ifHHAccWithSameEmailExist) {
        // for now disable binding hh acc and third party info
        HHAlert({ id: 'alert.error.socialLoginHHAccWithSameEmailExists', context: { email: payload.email } }, ALERT_TYPE.ERROR);
      } else {
        // redirect to signup
        props.push('/signup');
      }
    });
  };

  const genRandomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

  const githubLogin = (e) => {
    e.preventDefault();

    const githubState = genRandomId();
    props.resetGithubState(githubState);
    const params = {
      clientId: CONFIG.GITHUB_CLIENT_ID,
      redirectUri: CONFIG.GITHUB_REDIRECT_URL,
      scope: 'read:user&user:email',
      state: githubState,
      allowSignup: false
    };
    const getParams = () => {
      const {
        redirectUri, clientId, scope, state, allowSignup
      } = params;
      const githubAuthenLink = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${encodeURI(scope)}&state=${state}&allow_signup=${allowSignup}`;
      return githubAuthenLink;
    };
    window.open(getParams(), '_self');
  };

  const linkedinLogin = (e) => {
    e.preventDefault();

    const linkedinState = genRandomId();
    props.resetLinkedinState(linkedinState);
    const params = {
      clientId: CONFIG.LINKEDIN_CLIENT_ID,
      redirectUri: CONFIG.LINKEDIN_REDIRECT_URL,
      state: linkedinState,
      scope: 'r_liteprofile r_emailaddress',
      supportIE: false
    };
    const getParams = () => {
      const {
        redirectUri, clientId, state, scope, supportIE, redirectPath
      } = params;
      // TODO: Support IE 11
      const scopeParam = (scope) ? `&scope=${supportIE ? scope : encodeURI(scope)}` : '';
      const linkedinAuthenLink = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}${scopeParam}&state=${state}`;
      if (supportIE) {
        const redirectLink = `${window.location.origin}${redirectPath}?linkedin_redirect_url=${encodeURIComponent(linkedinAuthenLink)}`;
        return redirectLink;
      }
      return linkedinAuthenLink;
    };
    window.open(getParams(), '_self');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container>
        <Grid>
          <Grid.Row style={styles.gridRowPadding} centered>
            <Title>
              {translate('form.title.loginUser')}
            </Title>
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding}>
            <Grid.Column textAlign='left'>
              <Form.Field>
                <Field
                  name='email'
                  component={RegularInput}
                  otherProps={{
                    id: 'email',
                    placeholder: translate('form.placeholder.emailAddress'),
                    type: 'email',
                    label: translate('form.label.emailAddress')
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding}>
            <Grid.Column textAlign='left'>
              <Form.Field>
                <Field
                  name='password'
                  component={RegularInput}
                  otherProps={{
                    id: 'password',
                    placeholder: translate('form.placeholder.password'),
                    type: 'password',
                    label: translate('form.label.password')
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding}>
            {/* <Grid.Column width={9} textAlign='left'>
              <Form.Field>
                <Field
                  name='rememberMe'
                  component={RemeberMeCheckbox}
                  otherProps={{
                    id: 'rememberMe',
                    label: translate('form.label.rememberMe'),
                    isPrimary: false
                  }}
                />
              </Form.Field>
            </Grid.Column> */}
            <Grid.Column width={16} textAlign='right'>
              <ClickableText onClick={(e) => toResetPassword(e)}>
                {translate('forgot.password')}
              </ClickableText>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row centered>
            {/* <SubmitButton isPrimary>
              {translate('form.submitBtn.login')}
            </SubmitButton> */}
            <RegularButton
              isSubmitting={isSubmitting}
              label={translate('form.submitBtn.login')}
            />
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding}>
            <LineBorder />
            <ThirdPartyText>
              {translate('form.label.alertnativeLogin')}
            </ThirdPartyText>
            <LineBorder />
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding}>
            <Grid.Column width={16} textAlign='center' className='thirdPartiesCol'>
              <GithubIcon onClick={(e) => githubLogin(e)} />
              {!window.location.hostname.includes('event.hackhub.cn') &&
                <GoogleLogin
                  clientId={CONFIG.GOOGLE_CLIENT_ID}
                  render={renderProps => (
                    <GoogleIcon onClick={renderProps.onClick} />
                  )}
                  buttonText='Login'
                  onSuccess={res => googleLogin(res)}
                  // onFailure={responseGoogle}
                  cookiePolicy='single_host_origin'
                />
              }
              <LinkedinIcon onClick={(e) => linkedinLogin(e)} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding} centered>
            <ToSignupText>
              {translate('form.label.dontHaveAccount')}
            </ToSignupText>
          </Grid.Row>
          <Grid.Row style={styles.gridRowPadding} centered>
            <ToSignupLink onClick={(e) => toSignupLink(e)}>
              {translate('button.createNewAccount')}
            </ToSignupLink>
          </Grid.Row>
        </Grid>
      </Container>
    </Form>
  );
};

const Container = styled.div`
  margin-right: 60px;
  margin-left: 60px;
  margin-top: 40px;
  margin-bottom: 40px;

  .thirdPartiesCol {     
    button {
      @media (max-width: 363px) {
        margin: 10px;
      }
    }
  }
`;

const Title = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  color: #384455;
`;

const LineBorder = styled.hr`
  border: 1px solid #6A7380;
  width: 80px;

  @media (max-width:363px) {
    width: 40px;
  }
`;

const ThirdPartyText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #6A7380;
`;

const ToSignupText = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #676767;
`;

const ToSignupLink = styled.button.attrs(() => ({
  type: 'button'
}))`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #0095FA;
  border: none;
  background-color: transparent;
`;

const GoogleIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-google.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
`;

const GithubIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-github.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
  margin-right: 80px;
`;

const LinkedinIcon = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-image: url('/img/icons/thirdParty-linkedin.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
  background-color: #FFFFFF;
  border: none;
  margin-left: 80px;
`;

const ClickableText = styled.button.attrs(() => ({
  type: 'button'
}))`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  color: #0095FA;
  border: none;
  background-color: transparent;
`;

// const SubmitButton = styled(OrginalButton).attrs(() => ({
//   type: 'submit'
// }))`
//   width: 338px;
//   @media (max-width: 768px) {
//     width: auto;
//   }
// `;

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }), {
    signIn, googleLoginViaLogin, push, resetGithubState, resetLinkedinState, accountSignIn
  }),
  formikEnhancer
)(AccountLoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/accountLoginForm.js